module.exports = __webpack_public_path__ + "img/copper1.710de720.gif";